// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PurchasesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Recent ai_credit_purchases rows, newest-first — GET /ai/credits/purchases.
 * Full-gated only. READ-ONLY mirror; no reconciliation action lives here.
 */
import type { AiCredits_PurchaseRow } from './AiCredits_PurchaseRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PurchasesResponseDados {
rows: AiCredits_PurchaseRow[]
}

export type AiCredits_PurchasesResponse = ApiResponse<AiCredits_PurchasesResponseDados>;

registerResponseContract('AiCredits_PurchasesResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:              { type: 'number',  required: true },
      franquia_id:     { type: 'number',  required: true },
      pack_id:         { type: 'number',  required: true },
      charge_id:       { type: 'string',  required: true },
      currency:        { type: 'string',  required: true },
      price_cents:     { type: 'number',  required: false },
      credits_granted: { type: 'number',  required: false },
      status:          { type: 'string',  required: true },
      created_at:      { type: 'string',  required: false },
    },
  },
})
